import React from "react";
import { CUSTOM_RECTANGLE } from "./constants";

const Rectangle = ({ fillColor }) => {
    return <div className={CUSTOM_RECTANGLE + fillColor} />;
};

export default Rectangle;
